import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuInfo } from 'react-icons/lu';

import type { AcceptedOfferSource, OfferSource } from '../types';
import { useOfferExtraInfoState } from './useOfferExtraInfoState';
import { OfferExtraInfoDialog } from '~/features/leadDetails/components/BankCreditRequest/NewCreditRequest/RequestConfiguration/OfferExtraInfo/OfferExtraInfoDialog';

type OfferInfoProps = (AcceptedOfferSource | OfferSource) & {
    routeControlled?: boolean;
};

export const OfferExtraInfo: React.FC<OfferInfoProps> = ({ routeControlled = false, ...props }) => {
    const { t } = useTranslation();
    const supportsRoutedExtraInfo =
        props.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE ||
        props.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC;
    const { isOpen, isRouteControlled, setOpen } = useOfferExtraInfoState(
        props.offer.id,
        routeControlled && supportsRoutedExtraInfo,
    );
    const supportsExtraInfo = supportsRoutedExtraInfo || props.source === LOAN_REQUEST_OFFER_SOURCES.CONSORS;

    return (
        <>
            {!isRouteControlled && supportsExtraInfo && (
                <OfferExtraInfoDialog {...props} isOpen={isOpen} setIsOpen={setOpen} />
            )}

            <button
                type="button"
                aria-label={t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.TITLE')}
                onClick={() => setOpen(true)}
                className="inline-flex cursor-pointer text-blue"
                data-testid="info-icon"
            >
                <LuInfo className="size-5" />
            </button>
        </>
    );
};
